module.exports = __webpack_public_path__ + "static/media/Labels.f380b7c9.svg";